import React from "react";
import { Box, Stack, Typography, Link as MuiLink } from "@mui/material";
import HomeIcon from '@mui/icons-material/Home';
import ShareIcon from '@mui/icons-material/Share';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import LockIcon from '@mui/icons-material/Lock';
import InfoIcon from '@mui/icons-material/Info';
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';

export default function RedirectNavBar() {
  return (
<Box sx={{
  width: "100%",
  display: "flex",
  justifyContent: "center",
  mt: { xs: 2, md: 4 },
  mb: 3,
}}>
  <Box sx={{
    width: "100%",
    maxWidth: { xs: "100%", md: 1600 }, // đủ rộng cho desktop
    px: { xs: 1, md: 4 },
    py: 1.5,
    borderRadius: 999,
    background: "rgba(30,41,120,0.25)",
    boxShadow: "0 4px 32px #6366f133",
    backdropFilter: "blur(10px)",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 2,
    flexWrap: "nowrap",
    overflowX: { xs: "auto", md: "visible" }, // chỉ cho kéo ở mobile thôi!
    scrollbarWidth: "none", // ẩn thanh kéo Firefox
    "&::-webkit-scrollbar": { display: "none" }, // ẩn thanh kéo Chrome
  }}>
        {/* Menu trái */}
        <Stack direction="row" spacing={{ xs: 1, md: 2 }} sx={{ flexWrap: "nowrap" }}>
          <MuiLink href="/" underline="none" color="#fff" fontWeight={700} fontSize={{ xs: 15, md: 17 }} sx={{
            display: "flex", alignItems: "center", px: 1.2, borderRadius: 999,
            whiteSpace: "nowrap", // NGĂN XUỐNG HÀNG
            transition: "all .2s", "&:hover": { bgcolor: "#facc15", color: "#333" }
          }}>
            <HomeIcon sx={{ mr: 0.7, fontSize: 21 }} /> Trang chủ
          </MuiLink>
          <MuiLink href="https://visaothe.net" target="_blank" rel="noopener" underline="none" color="#fff" fontWeight={700} fontSize={{ xs: 15, md: 17 }} sx={{
            display: "flex", alignItems: "center", px: 1.2, borderRadius: 999,
            whiteSpace: "nowrap",
            transition: "all .2s", "&:hover": { bgcolor: "#facc15", color: "#333" }
          }}>
            <ShareIcon sx={{ mr: 0.7, fontSize: 21 }} /> Chia Sẻ Phần Mềm
          </MuiLink>
          <MuiLink href="https://upload.elecom-vn.com" target="_blank" rel="noopener" underline="none" color="#fff" fontWeight={700} fontSize={{ xs: 15, md: 17 }} sx={{
            display: "flex", alignItems: "center", px: 1.2, borderRadius: 999,
            whiteSpace: "nowrap",
            transition: "all .2s", "&:hover": { bgcolor: "#facc15", color: "#333" }
          }}>
            <CloudUploadIcon sx={{ mr: 0.7, fontSize: 21 }} /> Upload Ảnh
          </MuiLink>
        </Stack>
        {/* LOGO GIỮA */}
        <Typography variant="h5" fontWeight={900} sx={{
          px: 3,
          fontSize: { xs: 20, md: 28 },
          background: "linear-gradient(90deg,#facc15,#6366f1 80%)",
          backgroundClip: "text",
          WebkitBackgroundClip: "text",
          color: "transparent",
          WebkitTextFillColor: "transparent",
          textShadow: "0 2px 10px #0002",
          whiteSpace: "nowrap"
        }}>
          visaothe.<span style={{
            color: "#fff", WebkitTextFillColor: "#fff",
            fontWeight: 800, filter: "brightness(1.1)"
          }}>ShortLink</span>
        </Typography>
        {/* Menu phải */}
        <Stack direction="row" spacing={{ xs: 1, md: 2 }} sx={{ flexWrap: "nowrap" }}>
          <MuiLink href="https://2fa.visaothe.net" target="_blank" rel="noopener" underline="none" color="#fff" fontWeight={700} fontSize={{ xs: 15, md: 17 }} sx={{
            display: "flex", alignItems: "center", px: 1.2, borderRadius: 999,
            whiteSpace: "nowrap",
            transition: "all .2s", "&:hover": { bgcolor: "#facc15", color: "#333" }
          }}>
            <LockIcon sx={{ mr: 0.7, fontSize: 21 }} /> 2FA
          </MuiLink>
          <MuiLink href="https://visaothe.net/gioithieu" target="_blank" rel="noopener" underline="none" color="#fff" fontWeight={700} fontSize={{ xs: 15, md: 17 }} sx={{
            display: "flex", alignItems: "center", px: 1.2, borderRadius: 999,
            whiteSpace: "nowrap",
            transition: "all .2s", "&:hover": { bgcolor: "#facc15", color: "#333" }
          }}>
            <InfoIcon sx={{ mr: 0.7, fontSize: 21 }} /> Giới Thiệu
          </MuiLink>
          <MuiLink href="https://visaothe.net/donate/" target="_blank" rel="noopener" underline="none" color="#fff" fontWeight={700} fontSize={{ xs: 15, md: 17 }} sx={{
            display: "flex", alignItems: "center", px: 1.2, borderRadius: 999,
            whiteSpace: "nowrap",
            transition: "all .2s", "&:hover": { bgcolor: "#facc15", color: "#333" }
          }}>
            <VolunteerActivismIcon sx={{ mr: 0.7, fontSize: 21 }} /> Ủng Hộ
          </MuiLink>
        </Stack>
      </Box>
    </Box>
  );
}
